import { render, staticRenderFns } from "./ClientBaseViewContentPage.vue?vue&type=template&id=6c745df4&scoped=true&"
import script from "./ClientBaseViewContentPage.vue?vue&type=script&lang=js&"
export * from "./ClientBaseViewContentPage.vue?vue&type=script&lang=js&"
import style0 from "./ClientBaseViewContentPage.vue?vue&type=style&index=0&id=6c745df4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c745df4",
  null
  
)

export default component.exports